import {TableSettings} from '../../../tableSettings';

export const airExportMawbList:TableSettings = {
  tableVersion: 10050,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};

export const airExportVolumeWeight:TableSettings = {
  tableVersion: 1016,
  overflowX: 'hidden',
  overflowY: 'scroll',
  useStorage: true,
  flexResizer: true,
  headersColor: 'white',
  alternateRows: false,
  columns: [
    { accessor:'indicator', Header: '#', visible: true, resizable: false, sortable: false, initialWidthPercentage: 8.33, },
    { accessor:'length', Header: 'Length', visible: true, resizable: false, sortable: false, initialWidthPercentage: 13.89, },
    { accessor:'width', Header: 'Width', visible: true, resizable: false, sortable: false, initialWidthPercentage: 13.89, },
    { accessor:'height', Header: 'Height', visible: true, resizable: false, sortable: false, initialWidthPercentage: 13.89, },
    { accessor:'pcs', Header: 'Pkgs', visible: true, resizable: false, sortable: false, initialWidthPercentage: 13.89, },
    { accessor:'chgWeight', Header: 'Chrg KGS', visible: true, resizable: false, sortable: false, initialWidthPercentage: 15.28, },
    { accessor:'lChgWeight', Header: 'Chrg LBS', visible: true, resizable: false, sortable: false, initialWidthPercentage: 15.28, },
    { accessor:'scroll', Header: '', visible: true, resizable: false, sortable: false, initialWidthPercentage: 5.55, },
  ]
};

export const hawbBlDetailsHawbBody: TableSettings = {
  tableVersion: 1009,
  overflowX: 'hidden',
  overflowY: 'scroll',

  height: '170px',
  headersColor: 'white',
  useStorage: true,
  flexResizer: true,

  columns: [
    {
      Header: 'Billing Code',
      accessor: 'chgCodeName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 18.56,
    },
    {
      Header: 'Item Description',
      accessor: 'description',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 26.6,
    },
    {
      Header: 'Revenue',
      accessor: 'preRevenue',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.33,
    },
    {
      Header: 'Cost',
      accessor: 'preCost',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.33,
    },
    {
      Header: 'Revenue',
      accessor: 'colRevenue',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.33,
    },
    {
      Header: 'Cost',
      accessor: 'colCost',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 12.33,
    },
    {
      Header: 'A',
      accessor: 'agentShow',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 3.07,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.08,
    },
  ]
};

export const airExportChargeableItems:TableSettings = {
  tableVersion: 1014,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  height: '100%',
  useStorage: true,
  flexResizer: true,

  headersColor: 'white',
  alternateRows: true,
  columns: [
    { accessor:'chargeableItem', Header: 'Chargeable Item', visible: true, resizable: false, sortable: false, initialWidthPercentage: 56.76, },
    { accessor:'prepaid', Header: 'Prepaid', visible: true, resizable: false, sortable: false, initialWidthPercentage: 21.62, },
    { accessor:'collect', Header: 'Collect', visible: true, resizable: false, sortable: false, initialWidthPercentage: 21.62, },
    // { accessor:'scroll', Header: '', visible: true, resizable: false, sortable: false, initialWidthPercentage: 5.0, },
  ]
};

export const airExportHawbList:TableSettings = {
  tableVersion: 1023,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: []
};

export const airExportFace:TableSettings = {
  tableVersion: 1007,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  useStorage: true,
  flexResizer: true,

  headersColor: 'teal',
  alternateRows: true,
  columns: [
    { accessor:'no', Header: 'Package(s)', visible: true, resizable: true, sortable: false, initialWidthPercentage: 11.76, },
    { accessor:'gw', Header: 'Gross Weight', visible: true, resizable: true, sortable: false, initialWidthPercentage: 15.68, },
    { accessor:'kg', Header: 'KG LB', visible: true, resizable: true, sortable: false, initialWidthPercentage: 7.84, },
    // { accessor:'rateClass', Header: 'Rate Class', visible: true, resizable: true, sortable: false, initialWidthPercentage: 10, },
    { accessor:'commodity', Header: 'Commodity Item #', visible: true, resizable: true, sortable: false, initialWidthPercentage: 17.64, },
    { accessor:'chw', Header: 'Chargeable Weight', visible: true, resizable: true, sortable: false, initialWidthPercentage: 15.68, },
    { accessor:'r', Header: 'Rate / Charge', visible: true, resizable: true, sortable: false, initialWidthPercentage: 15.68, },
    { accessor:'total', Header: 'Total', visible: true, resizable: true, sortable: false, initialWidthPercentage: 15.68, },
  ]
};

export const airExportFaceRate:TableSettings = {
  tableVersion: 1013,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  useStorage: true,
  flexResizer: true,

  headersColor: 'teal',
  alternateRows: true,
  columns: [
    { accessor:'no', Header: 'Package(s)', visible: true, resizable: true, sortable: false, initialWidthPercentage: 14.15, },
    { accessor:'gw', Header: 'Gross Weight', visible: true, resizable: true, sortable: false, initialWidthPercentage: 14.15, },
    { accessor:'kg', Header: 'KG LB', visible: true, resizable: true, sortable: false, initialWidthPercentage: 5.66, },
    { accessor:'rateClass', Header: 'Rate Class', visible: true, resizable: true, sortable: false, initialWidthPercentage: 7.54, },
    { accessor:'commodity', Header: 'Commodity Item #', visible: true, resizable: true, sortable: false, initialWidthPercentage: 14.15, },
    { accessor:'chw', Header: 'Chargeable Weight', visible: true, resizable: true, sortable: false, initialWidthPercentage: 14.15, },
    { accessor:'r', Header: 'Rate / Charge', visible: true, resizable: true, sortable: false, initialWidthPercentage: 15.09, },
    { accessor:'total', Header: 'Total', visible: true, resizable: true, sortable: false, initialWidthPercentage: 15.09, },
  ]
};

export const airExportHawbFaceRate:TableSettings = {
  tableVersion: 1008,
  overflowX: 'hidden',
  overflowY: 'hidden',
  
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'no', Header: 'Package(s)', visible: true, resizable: true, sortable: false, initialWidthPercentage: 11.76, },
    { accessor:'gw', Header: 'Gross Weight', visible: true, resizable: true, sortable: false, initialWidthPercentage: 15.69, },
    { accessor:'kg', Header: 'KG LB', visible: true, resizable: true, sortable: false, initialWidthPercentage: 7.83, },
    { accessor:'commodity', Header: 'Commodity Item #', visible: true, resizable: true, sortable: false, initialWidthPercentage: 17.65, },
    { accessor:'chw', Header: 'Chargeable Weight', visible: true, resizable: true, sortable: false, initialWidthPercentage: 15.69, },
    { accessor:'r', Header: 'Rate / Charge', visible: true, resizable: true, sortable: false, initialWidthPercentage: 15.69, },
    { accessor:'total', Header: 'Total', visible: true, resizable: true, sortable: false, initialWidthPercentage: 15.69, },
  ]
};

export const hawbAeHblPoBodyLineItems:TableSettings = {
  tableVersion: 1012,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '300px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    { Header: '#', accessor: 'indicator', resizable: false, sortable: false, visible: true, initialWidthPercentage: 2.63, },
    { Header: 'PO #', accessor: 'poNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.77, },
    { Header: 'SKU', accessor: 'skuNo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 13.16, },
    { Header: 'HTS Code', accessor: 'htsCode', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.02, },
    { Header: 'C/O', accessor: 'coo', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.77, },
    { Header: 'Description', accessor: 'description', resizable: false, sortable: false, visible: true, initialWidthPercentage: 15.79, },
    { Header: 'Qty', accessor: 'shipQty', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.77, },
    { Header: 'Unit', accessor: 'shipUnit', resizable: false, sortable: false, visible: true, initialWidthPercentage: 7.02, },
    { Header: 'Unit Price', accessor: 'uPrice', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.77, },
    { Header: 'KGS (G)', accessor: 'kgs', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.77, },
    { Header: 'KGS (C)', accessor: 'cKgs', resizable: false, sortable: false, visible: true, initialWidthPercentage: 8.77, },
    { Header: '', accessor: 'scroll', resizable: false, sortable: false, visible: true, initialWidthPercentage: 1.76, },
  ]
};

export const batchPrintTable:TableSettings = {
  tableVersion: 10045,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '150px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '',
      accessor: 'selected',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4.41,
    },
    {
      Header: 'HAWB #',
      accessor: 'hblNo',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 16.17,
    },
    {
      Header: 'Shipper',
      accessor: 'shipperFullName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.59,
    },
    {
      Header: 'Fax',
      accessor: 'hasShipperFax',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Email',
      accessor: 'hasShipperEmail',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 8.82,
    },
    {
      Header: 'Customer',
      accessor: 'customerName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20.59,
    },
    {
      Header: 'Agent',
      accessor: 'agentName',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 17.65,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 2.94,
    },
  ]
};

export const airExportQuotationList:TableSettings = {
  tableVersion: 10049,
  overflowX: 'scroll',
  overflowY: 'scroll',
  
  height: '100%',
  useStorage: true,
  flexResizer: false,

  headersColor: 'gray',
  alternateRows: true,
  columns: [
    { accessor:'status', Header: '', visible: true, width: 30, canBeHidden: false, resizable: false, sortable: false },
    { accessor:'quoteNo', Header: 'Quotation #', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text', defaultColumnFocus: true },
    { accessor:'quoteDate', Header: 'Date', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'operator', Header: 'Quote By', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'validBy', Header: 'Valid By', visible: true, width: 75, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'customer', Header: 'Customer', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'contactName', Header: 'Contact', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text',  },
    // { accessor:'hBookingNo', Header: 'Cust. Book Rqst No', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'serviceType', Header: 'Service Type', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'commodity', Header: 'Commodity', visible:true, width: 150, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'plofRec', Header: 'Place of Receipt', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'loadingPort', Header: 'Departure Airport', visible:true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'discharge', Header: 'Arrival Airport', visible: true, width: 120, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'sManID', Header: 'Salesperson', visible:true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u2Date', Header: 'Update', visible: true, width: 100, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'date' },
    { accessor:'u2ID', Header: 'Updated', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
    { accessor:'u1ID', Header: 'Created', visible: true, width: 80, canBeHidden: true, resizable: true, sortable: true, filterable: true, filterType: 'text' },
  ]
};

export const aeQuotationBillingInfo:TableSettings = {
  tableVersion: 1003,
  overflowX: 'hidden',
  overflowY: 'scroll',
  
  height: '240px',
  useStorage: true,
  flexResizer: true,

  headersColor: 'gray',
  columns: [
    {
      Header: '#',
      accessor: 'indicator',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 4,
    },
    {
      Header: 'Billing Code',
      accessor: 'billingCode',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 15,
    },
    {
      Header: 'Item description',
      accessor: 'itemDescription',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 20,
    },
    {
      Header: 'CUR',
      accessor: 'currency',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 5,
    },
    {
      Header: 'Rate',
      accessor: 'rate',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 14.0,
    },
    {
      Header: 'Qty',
      accessor: 'qty',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage:  13.5,
    },
    {
      Header: 'Amount',
      accessor: 'amount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13,
    },
    {
      Header: 'USD Amount',
      accessor: 'convertedAmount',
      resizable: true,
      sortable: false,
      visible: true,
      initialWidthPercentage: 13,
    },
    {
      Header: '',
      accessor: 'scroll',
      resizable: false,
      sortable: false,
      visible: true,
      initialWidthPercentage: 1.50,
    },
  ]
};